import { render, staticRenderFns } from "./fleet_assistant.vue?vue&type=template&id=0f59a23e&scoped=true&"
import script from "./fleet_assistant.vue?vue&type=script&lang=js&"
export * from "./fleet_assistant.vue?vue&type=script&lang=js&"
import style0 from "./fleet_assistant.vue?vue&type=style&index=0&id=0f59a23e&scoped=true&lang=css&"
import style1 from "./fleet_assistant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59a23e",
  null
  
)

export default component.exports